import { TabButton } from "@ui-kit/TabButton/TabButton";
import { FunctionComponent } from "react";

interface AuthSubmitButtonProps {
  onPress?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  label: string;
  disabled: boolean;
}

export const AuthSubmitButton: FunctionComponent<AuthSubmitButtonProps> = ({
  onPress,
  label,
  disabled,
}) => {
  return (
    <TabButton
      label={label}
      variant="primary"
      size="large"
      fullWidth={true}
      onPress={onPress}
      disabled={disabled}
      htmlType="submit"
    />
  );
};
